import BaseAPI from 'api/api'

/** Feature configs: addon settings per aboutUsId (enabled, useAllBranches, dateExpiredAll, branches) */
export interface FeatureConfigBranchItem {
  branchId: number
  dateExpired: string | null
}
export interface FeatureConfigItem {
  enabled: boolean
  useAllBranches: boolean
  dateExpiredAll: string | null
  branches: FeatureConfigBranchItem[]
}
export type FeatureConfigsMap = Record<string, FeatureConfigItem>

export interface FindAllInterface {
    clinicNameTh: string,
    clinicNameEn: string,
    phoneNo: string,
    line: string,
    website: string,
    email: string,
    package: string,
    countryId: number,
    provinceId: number,
    districtId: number,
    subDistrictId: number,
    postcode: string,
    addressTh: string,
    addressEn: string,
    hasCertificate: string,
    reBranchCnNumber: string,
    formatBranchCnNumber: string,
    notilineAppointmentCreate: string,
    notilineAppointmentUpdate: string,
    notilineAppointmentPreday: string,
    notilineAppointmentDay: string,
    notilineAppointmentStatus: string,
    cnNumber: string,
    branchCnNumbers: []
}
export default class AboutUs extends BaseAPI {
    static findAboutUs(): Promise<any> {
        return this.api.get('about-us').then((res) => res)
    }

    static updateAboutUs(props: any): Promise<any> {
        return this.api.post('about-us', props).then((res) => res)
    }

    static detailClinic(branchId: number): Promise<any> {
        return this.api.get(`clinic/${branchId}/info`).then((res) => res)
    }

    /** Feature configs (addon settings) */
    static getFeatureConfigs(aboutUsId: number): Promise<{ data: FeatureConfigsMap }> {
        return this.api.get('feature-configs', { params: { aboutUsId } }).then((res) => res)
    }

    static saveFeatureConfigs(aboutUsId: number, configs: FeatureConfigsMap): Promise<any> {
        return this.api.put('feature-configs', { aboutUsId, configs }).then((res) => res)
    }
}
